<!-- eslint-disable max-len -->
<template>
  <div
    v-if="is_ready"
    id="form-master"
    class="form-master">
    <template v-for="(field, index) in dataFields">
      <div :key="index">
        <b-form-group
          v-if="field.type === 'text' && !field.is_delete"
          :class="{'error-input' : $v.formData[String(field.id)].$error}">
          <label :for="index"> {{ field.name }} <span
            v-if="field.is_mandatory"
            style="color:red" >*</span></label>
          <j-input
            v-model="$v.formData[String(field.id)].$model"
            :id="index"
            :disabled="field.is_editable || isDisabled"
            :placeholder="field.placeholder"/>
        </b-form-group>
        <b-form-group
          v-if="field.type === 'number' && !field.is_delete"
          :class="{'error-input' : $v.formData[String(field.id)].$error}">
          <label :for="index"> {{ field.name }} <span
            v-if="field.is_mandatory"
            style="color:red">*</span></label>
          <j-input
            v-model="$v.formData[String(field.id)].$model"
            :id="index"
            :disabled="field.is_editable || isDisabled"
            :placeholder="field.placeholder"
            type="number"/>
        </b-form-group>
        <b-form-group
          v-if="field.type === 'number_decimal' && !field.is_delete"
          :class="{'error-input' : $v.formData[String(field.id)].$error}">
          <label :for="index"> {{ field.name }} <span
            v-if="field.is_mandatory"
            style="color:red">*</span></label>
          <j-input
            v-model="$v.formData[String(field.id)].$model"
            :id="index"
            :disabled="field.is_editable || isDisabled"
            :placeholder="field.placeholder"
            type="number"/>
        </b-form-group>
        <b-form-group
          v-if="field.type === 'currency' && !field.is_delete"
          :class="{'error-input' : $v.formData[String(field.id)].$error}">
          <label :for="index">{{ field.name }} <span
            v-if="field.is_mandatory"
            style="color:red" >*</span></label>
          <j-currency
            v-model="$v.formData[String(field.id)].$model"
            :options="exampleOptionCurrency"
            :placeholder="field.placeholder"
            :disabled="field.is_editable || isDisabled"
            :input_mode="true"/>
        </b-form-group>
        <b-form-group
          v-if="field.type === 'textarea' && !field.is_delete"
          :class="{'error-input' : $v.formData[String(field.id)].$error}">
          <label :for="index"> {{ field.name }} <span
            v-if="field.is_mandatory"
            style="color:red" >*</span></label>
          <j-textarea
            :disabled="field.is_editable || isDisabled"
            v-model="$v.formData[String(field.id)].$model"
            :id="index"
            :placeholder="field.placeholder"/>
        </b-form-group>
        <b-form-group
          v-if="field.type === 'date' && !field.is_delete"
          :class="{'error-input' : $v.formData[String(field.id)].$error}">
          <label :for="index">{{ field.name }} <span
            v-if="field.is_mandatory"
            style="color:red" >*</span></label>
          <j-datepicker
            v-model="$v.formData[String(field.id)].$model"
            :disabled="field.is_editable || isDisabled"
            :id="index"
            :placeholder="field.placeholder"
            format="MMM dd, yyyy"/>
        </b-form-group>
        <b-form-group
          v-if="field.type === 'time' && !field.is_delete"
          :class="{'error-input' : $v.formData[String(field.id)].$error}">
          <label :for="index">{{ field.name }} <span
            v-if="field.is_mandatory"
            style="color:red" >*</span></label>
          <j-clockpicker
            v-model="$v.formData[String(field.id)].$model"
            :placeholder="field.placeholder"
            :disabled="field.is_editable || isDisabled"/>
        </b-form-group>
        <b-form-group
          v-if="field.type === 'date_time' && !field.is_delete"
          :class="{'error-input' : $v.formData[String(field.id)].$error}">
          <label :for="index">{{ field.name }} <span
            v-if="field.is_mandatory"
            style="color:red" >*</span> </label>
          <j-date-time-v2
            :type="'datetime'"
            v-model="$v.formData[String(field.id)].$model"
            :placeholder="field.placeholder"/>
        </b-form-group>
        <b-form-group
          v-if="field.type === 'pegawai' && !field.is_delete"
          :class="{'error-input' : $v.formData[String(field.id)].$error}">
          <label :for="index">{{ field.name }} <span
            v-if="field.is_mandatory"
            style="color:red" >*</span></label>
          <j-multi-select
            v-model="$v.formData[String(field.id)].$model"
            :options="listPegawai"
            :placeholder="field.placeholder"
            :disabled="field.is_editable || isDisabled"
            label="name"/>
        </b-form-group>
        <b-form-group
          v-if="field.type === 'multiple_selection_anggota_ekskul' && !field.is_delete"
          :class="{'error-input' : $v.formData[String(field.id)].$error}">
          <label :for="index">{{ field.name }} <span
            v-if="field.is_mandatory"
            style="color:red" >*</span></label>
          <j-multi-select
            v-model="$v.formData[String(field.id)].$model"
            :options="listAnggotaEkskul"
            :placeholder="field.placeholder"
            :disabled="field.is_editable || isDisabled"
            label="name"/>
        </b-form-group>
        <b-form-group
          v-if="field.type === 'single_selection_kelas' && !field.is_delete"
          :class="{'error-input' : $v.formData[String(`${field.id}2`)].$error}">
          <label :for="index">Tahun Ajaran <span
            v-if="field.is_mandatory"
            style="color:red" >*</span></label>
          <j-single-select
            v-model="$v.formData[String(`${field.id}2`)].$model"
            :options="listTahunAjaran"
            :placeholder="'Select Tahun Ajaran'"
            :disabled="field.is_editable || isDisabled"
            label="name"
            @getData="getDataKelas(field)"/>
        </b-form-group>
        <b-form-group
          v-if="field.type === 'single_selection_kelas' && !field.is_delete"
          :class="{'error-input' : $v.formData[String(field.id)].$error}">
          <label :for="index">{{ field.name }} <span
            v-if="field.is_mandatory"
            style="color:red" >*</span></label>
          <j-single-select
            v-model="$v.formData[String(field.id)].$model"
            :options="listKelas"
            :disabled="field.is_editable || isDisabled"
            :placeholder="field.placeholder"
            label="name"/>
        </b-form-group>
        <b-form-group
          v-if="field.type === 'multiple_selection_kelas' && !field.is_delete"
          :class="{'error-input' : $v.formData[String(field.id)].$error}">
          <label :for="index">{{ field.name }} <span
            v-if="field.is_mandatory"
            style="color:red" >*</span></label>
          <j-multi-select
            v-model="$v.formData[String(field.id)].$model"
            :options="listKelas"
            :placeholder="field.placeholder"
            :disabled="field.is_editable || isDisabled"
            label="name"/>
        </b-form-group>
        <b-form-group
          v-if="field.type === 'single_selection_siswa' && !field.is_delete"
          :class="{'error-input' : $v.formData[String(field.id)].$error}">
          <label :for="index">{{ field.name }} <span
            v-if="field.is_mandatory"
            style="color:red" >*</span></label>
          <j-single-select
            v-model="$v.formData[String(field.id)].$model"
            :load-options="loadOptionsSiswa"
            :is-async="true"
            :cache-option="false"
            :disabled="field.is_editable || isDisabled"
            :default-options="false"
            :placeholder="field.placeholder"
            value-format="object"
            label="name"/>
        </b-form-group>
        <b-form-group
          v-if="field.type === 'multiple_selection_siswa' && !field.is_delete"
          :class="{'error-input' : $v.formData[String(field.id)].$error}">
          <label :for="index">{{ field.name }} <span
            v-if="field.is_mandatory"
            style="color:red" >*</span></label>
          <j-multi-select
            v-model="$v.formData[String(field.id)].$model"
            :load-options="loadOptionsSiswa"
            :is-async="true"
            :cache-option="false"
            :placeholder="field.placeholder"
            :disabled="field.is_editable || isDisabled"
            value-format="object"
            label="name"/>
        </b-form-group>
        <b-form-group
          v-if="field.type === 'single_selection' && !field.is_delete"
          :class="{'error-input' : $v.formData[String(field.id)].$error}">
          <label :for="index">{{ field.name }} <span
            v-if="field.is_mandatory"
            style="color:red" >*</span></label>
          <j-single-select
            v-model="$v.formData[String(field.id)].$model"
            :options="field.options"
            :disabled="field.is_editable || isDisabled"
            :placeholder="field.placeholder"
            label="name"/>
        </b-form-group>

      </div>
    </template>
  </div>
</template>

<script>
/* eslint-disable no-nested-ternary, max-len, no-unused-vars, no-console */
import { required } from 'vuelidate/lib/validators';
import { mapActions, mapState } from 'vuex';
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';

function getValidation(field) {
  return !field.is_delete ? (field.is_mandatory ? { required } : {}) : {};
}
function generateValidations(fieldList, isDetail) {
  const validations = {
    formData: {},
  };
  fieldList.forEach((each) => {
    if (each.type === 'single_selection_kelas') {
      validations.formData[each.id] = getValidation(each);
      validations.formData[Number(`${each.id}2`)] = getValidation(each);
    } else {
      validations.formData[each.id] = getValidation(each);
    }
  });
  return validations;
}
function getDataModel(field, isDetail) {
  if (isDetail) {
    return field.value;
  }
  return null;
}
function generateDataModel(fieldList, isDetail) {
  const fields = {};
  fieldList.forEach((each) => {
    if (each.type === 'single_selection_kelas') {
      fields[each.id] = getDataModel(each, isDetail);
      fields[Number(`${each.id}2`)] = isDetail ? each.tahun_ajaran : null;
    } else {
      fields[each.id] = getDataModel(each, isDetail);
    }
  });
  return fields;
}

export default {
  name: 'JFormBase',
  filters: {
    counterIndexGroup(val) {
      return Number(val) + 1;
    },
  },
  props: {
    dataFields: {
      type: Array,
      default: () => [],
    },
    isDetail: {
      type: Boolean,
      default: () => false,
    },
    isDisabled: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      is_ready: false,
      formData: {},
      exampleOptionCurrency: {
        digitGroupSeparator: '.',
        decimalCharacter: ',',
        decimalCharacterAlternative: '.',
        currencySymbol: 'Rp',
        currencySymbolPlacement: 'p',
        roundingMethod: 'U',
        minimumValue: '0',
        maximumValue: '99999999999999',
      },
      listPegawai: [],
      listAnggotaEkskul: [],
      listKelas: [],
      listTahunAjaran: [],
    };
  },
  computed: {
  },
  beforeCreate() {
    const fieldList = this.$options.propsData.dataFields;
    const isDetail = this.$options.propsData.isDetail;
    if (typeof fieldList !== 'undefined' && isDetail !== 'undefined') {
      this.$options.validations = generateValidations(fieldList, isDetail);
    }
  },
  created() {
    const fieldList = this.dataFields;
    if (fieldList) {
      this.formData = generateDataModel(fieldList, this.$options.propsData.isDetail);

      fieldList.forEach((e) => {
        if (e.type === 'pegawai') {
          this.getListPegawai().then((res) => {
            this.listPegawai = res.data.data;
          });
        }

        if (e.type === 'single_selection_kelas') {
          const params = {
            pagination: {
              query: '',
              query_type: '',
            },
          };
          this.getListTahunAjaran(params).then((res) => {
            this.listTahunAjaran = res.data.data.map(el => ({
              id: el.tahunajaran,
              name: el.tahunajaran,
            }));
          });

          if (this.isDetail && e.tahun_ajaran) {
            const paramsKelas = {
              pagination: {
                query: e.tahun_ajaran,
                query_type: 'tahunajaran',
              },
            };
            this.getListKelas(paramsKelas).then((res) => {
              this.listKelas = res.data.data;
            });
          }
        }

        // if (e.type === 'multiple_selection_anggota_ekskul') {
        //   const paramAnggota = {
        //     kode_ekskul: e.config ? e.config.kode_ekskul : '',
        //     tahunajaran: e.config ? e.config.tahunajaran : '',
        //   };
        //   this.getListAnggota(paramAnggota).then((res) => {
        //     this.listAnggotaEkskul = res.data.data.map(el => ({
        //       id: el.nis,
        //       name: el.nama_siswa,
        //     }));
        //   });
        // }
      });
      this.is_ready = true;
    }
  },
  updated() {
    if (this.dataFields) {
      const elem = document.getElementsByClassName('error-input');
      if (this.$v.formData.$error && elem[0]) {
        elem[0].scrollIntoView();
        return false;
      }
      return true;
    }
    return false;
  },
  methods: {
    ...mapActions('jStoreKurikulum', ['getListPegawai']),
    ...mapActions('jStoreKesiswaan', ['getListAnggota', 'getListTahunAjaran', 'getListKelas']),

    getDataKelas(field) {
      const params = {
        pagination: {
          query: this.formData[`${field.id}2`],
          query_type: 'tahunajaran',
        },
      };
      this.getListKelas(params).then((res) => {
        this.listKelas = res.data.data;
      });
    },

    setParamTahunAjaran(data) {
      const paramAnggota = {
        kode_ekskul: data.kode_ekskul || '',
        tahunajaran: data.tahunajaran || '',
      };
      this.getListAnggota(paramAnggota).then((res) => {
        this.listAnggotaEkskul = res.data.data.map(el => ({
          id: el.nis,
          name: el.nama_siswa,
        }));
      });
    },

    loadOptionsSiswa({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH && searchQuery !== null) {
        if (searchQuery.length > 2) {
          const reqData = {
            pagination: {
              limit: 50,
              page: 1,
              column: '',
              ascending: true,
              query: searchQuery,
              query_type: '',
            },
          };
          this.$store.dispatch('jStoreKurikulum/getSiswa', { reqData, callback });
        } else {
          callback(null, false);
        }
      }
    },
    validateForm() {
      this.$v.formData.$reset();
      this.$v.formData.$touch();
      return this.$v.formData.$error;
    },
    getData() {
      return new Promise((resolve, reject) => {
        this.$v.formData.$touch();
        if (!this.$v.formData.$error) {
          this.getComposedDataReq().then((data) => {
            resolve(data);
          });
        } else {
          reject(null);
        }
      });
    },
    getValueField(field) {
      let value;
      if (field.type === 'date') {
        value = this.formData[field.id] ?
          this.$moment(this.formData[field.id]).format('YYYY-MM-DD') : '';
      } else if (field.type === 'date_time') {
        value = this.formData[field.id] ?
          this.$moment(this.formData[field.id]).format('YYYY-MM-DD HH:mm') : '';
      } else {
        value = this.formData[field.id];
      }
      return value;
    },
    getFieldFormatReq(dataField, value) {
      return new Promise((resolve) => {
        const result = {
          id: dataField.id,
          name: dataField.name,
          type: dataField.type,
          placeholder: dataField.placeholder,
          field_key: dataField.field_key,
          value,
          is_mandatory: dataField.is_mandatory,
          is_delete: dataField.is_delete,
          is_editable: dataField.is_editable,
        };
        resolve(result);
      });
    },
    getComposedDataReq() {
      return new Promise((resolve) => {
        const additionalData = [];
        this.dataFields.forEach((eachField) => {
          const value = this.getValueField(eachField);
          this.getFieldFormatReq(eachField, value).then((eachDataField) => {
            additionalData.push(eachDataField);
          });
        });
        resolve(additionalData);
      });
    },
  },
  validations() {
    return {};
  },
};
</script>



// WEBPACK FOOTER //
// src/views/kurikulum/additional-info/jFormBase.vue